/**
 * AP · ATC price × quantity (2026-08-16, user): pill giá trong nút Add to cart
 * nhân theo số lượng đang chọn. Unit price đọc từ data-unit (cents, morph theo
 * variant), format theo shop.money_format (data-money). Nghe input/change +
 * click nút +/- của quantity-selector trong cùng product form.
 */
(function () {
  'use strict';
  function fmt(cents, moneyFormat) {
    var v = (cents / 100).toFixed(2);
    var whole = v.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var s = whole + '.' + v.split('.')[1];
    var f = moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function update(root) {
    var pill = root.querySelector('.ap-atc-price');
    if (!pill) return;
    var unit = parseInt(pill.getAttribute('data-unit'), 10);
    if (!unit) return;
    var qtyInput = root.querySelector('.quantity-selector input, input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var next = fmt(unit * qty, pill.getAttribute('data-money'));
    if (pill.textContent === next) return; // guard: không ghi lại → không kích MutationObserver vòng lặp
    pill.textContent = next;
  }
  function rootOf(el) {
    return el.closest('.product-details, product-form-component, .product-information, form[action*="/cart/add"]') || document;
  }
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('.quantity-selector input, input[name="quantity"]')) update(rootOf(e.target));
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.quantity-selector input, input[name="quantity"]')) update(rootOf(e.target));
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.quantity-selector button') : null;
    if (b) setTimeout(function () { update(rootOf(b)); }, 30);
  }, true);
  // sau khi Horizon morph section (đổi variant) → pill reset về unit → tính lại
  // Horizon morph section khi đổi variant → pill reset về unit → tính lại (chỉ nghe childList/attr,
  // KHÔNG nghe characterData; update() có guard nên không tự kích lại)
  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; var pd = document.querySelector('.product-details'); if (pd) update(pd); }, 50);
  });
  function init() {
    var pd = document.querySelector('.product-details');
    if (pd) { mo.observe(pd, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-unit', 'value'] }); update(pd); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
